/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AccountBalanceOutlined,
    AssuredWorkloadOutlined,
    BadgeOutlined,
    ChecklistOutlined,
    DashboardOutlined,
    GroupOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Inicio from "./Secciones/Seccion_Inicio";
import Seccion_Depositos from "./Secciones/Seccion_Depositos";
import Seccion_Retiros from "./Secciones/Seccion_Retiros";
import Seccion_Soporte from "./Secciones/Seccion_Soporte";
import Seccion_Cuentas from "./Secciones/Seccion_Cuentas";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Movimientos from "./Secciones/Seccion_Movimientos";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >

            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Cuentas',
        icono: GroupOutlined,
        camino: '/Cuentas',
        categoria: 'Cuentas',
        Componente: <Seccion_Cuentas/>
    },
    {
        nombre: 'Movimientos',
        icono: ChecklistOutlined,
        camino: '/Movimientos',
        categoria: 'Cuentas',
        Componente: <Seccion_Movimientos/>
    },
    {
        nombre: 'Depositos',
        icono: AssuredWorkloadOutlined,
        camino: '/Depositos',
        categoria: 'Acciones',
        Componente: <Seccion_Depositos/>
    },
    {
        nombre: 'Retiros',
        icono: AccountBalanceOutlined,
        camino: '/Retiros',
        categoria: 'Acciones',
        Componente: <Seccion_Retiros/>
    },
    {
        nombre: 'Soporte',
        icono: DashboardOutlined,
        camino: '/Inicio',
        categoria: 'Soporte',
        Componente: <Seccion_Soporte/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = [
    {
        camino: '/cuenta/:id',
        Componente: <Seccion_Inicio/>
    },
]

const seccionesPerfil = []

const notificaciones = {}